export default ({ axios, mapQueryString, withoutInvalidValues, toFormData }) => ({
    index: (query = {}) => axios.get(`/banners${mapQueryString(query)}`),
    show: (id) => axios.get(`/banners/${id}`),
    store: (data) => axios.post(`/banners`, toFormData(withoutInvalidValues(data))),
    update: (id, data) => axios.patch(`/banners/${id}`, data),
    delete: (id) => axios.delete(`/banners/${id}`),
})